import Glossary from '../components/Glossary/Glossary'
import KnowledgeBase from '../components/KnowledgeBase/KnowledgeBase'

const routes = [
  {
    path: 'glossary/group',
    name: 'kb.glossary',
    component: Glossary
  },
  {
    path: '',
    name: 'kb.index',
    component: KnowledgeBase
  },
]

export default routes


// WEBPACK FOOTER //
// ./src/apps/help/router/routes_kb.js